<div class="timeline-bar" role="img" tabindex="0" [attr.aria-label]="tooltip" [matTooltip]="tooltip" matTooltipClass="multiline-tooltip">
  @for (segment of segments; track $index) {
    <div class="timeline-segment" [ngStyle]="getSegmentStyle(segment)"></div>
  }
</div>
